import type { Namespaces } from 'bundles/epic/__generated__/namespaces';
import GrowthDiscoveryExperiments from 'bundles/epic/clients/GrowthDiscovery';
import type { MerchandisingHeroModuleFieldsFragment } from 'bundles/front-page/__generated__/contentfulTypes';

export const getRegionalExperiment = () => {
  const experimentNames = [
    'regional2025MarchPromoGlobal',
    'regional2025MarchPromoGermany',
    'regional2025MarchPromoFrance',
    'regional2025MarchPromoSpain',
    'regional2025MarchPromoIndia',
    'regional2025MarchPromoEmergingMarkets',
    'regional2025MarchPromoLatam',
  ] as Array<keyof Namespaces['GrowthDiscovery']>;

  return experimentNames.find((name) => GrowthDiscoveryExperiments.get(name) === true);
};

export const getRegionName = (experimentName: keyof Namespaces['GrowthDiscovery']) => {
  switch (experimentName) {
    case 'regional2025MarchPromoGlobal':
      return 'global';
    case 'regional2025MarchPromoLatam':
      return 'latam';
    case 'regional2025MarchPromoGermany':
      return 'germany';
    case 'regional2025MarchPromoIndia':
      return 'india';
    case 'regional2025MarchPromoFrance':
      return 'france';
    case 'regional2025MarchPromoEmergingMarkets':
      return 'emerging';
    case 'regional2025MarchPromoSpain':
      return 'spain';
    default:
      return '';
  }
};

export const getRegionalContent = (
  regionalHeroModules?: Array<MerchandisingHeroModuleFieldsFragment | null> | null,
  experimentName?: keyof Namespaces['GrowthDiscovery']
) => {
  if (!regionalHeroModules?.length || !experimentName) {
    return undefined;
  }

  return regionalHeroModules.find((module) => module?.region?.toLowerCase() === getRegionName(experimentName));
};
